// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__eJ6Sv","hand":"Home_hand__UWazP","wave":"Home_wave__KjzRq"};